import axios from "axios";

/**
 * Answer of `click-to-sign` and `click-to-sign/decline-sign-request` (HTTP 400,
 * body `{ message }`) when the approving manager acts before the employee who
 * owns the document has signed it.
 */
export const OWNER_MUST_SIGN_FIRST = "owner_must_sign_first";

/**
 * Translation key to show for a failed sign or decline call: the specific
 * message when the server says the employee has to sign first, otherwise the
 * caller's generic key.
 */
export function clickSignErrorKey(error: unknown, genericKey: string): string {
  const message = axios.isAxiosError<{ message?: string }>(error)
    ? error.response?.data?.message
    : undefined;
  return message === OWNER_MUST_SIGN_FIRST ? OWNER_MUST_SIGN_FIRST : genericKey;
}
